import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from '@mui/material';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import apiClient from '../api/client';

export default function RegisterPage({ onLogin }) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [form, setForm] = useState({ first_name: '', last_name: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  if (!token) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
        <Card sx={{ width: 400 }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h5" fontWeight={700} mb={2}>Invalid link</Typography>
            <Alert severity="error" sx={{ mb: 3 }}>This registration link is missing or malformed.</Alert>
            <Button component={Link} to="/login" variant="outlined">Back to sign in</Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await apiClient.post('/auth/register', { ...form, invite_token: token });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onLogin(data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Card sx={{ width: 400 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" fontWeight={700} mb={1}>Create your account</Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>
            Complete your registration below.
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="First Name" value={form.first_name} onChange={set('first_name')} required size="small" autoFocus />
            <TextField label="Last Name" value={form.last_name} onChange={set('last_name')} required size="small" />
            <TextField label="Password" type="password" value={form.password} onChange={set('password')} required size="small" inputProps={{ minLength: 8 }} />
            <Button type="submit" variant="contained" disabled={loading} sx={{ mt: 1 }}>
              {loading ? 'Creating account…' : 'Create Account'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
